import {
  BaseQueryFn,
  MutationDefinition,
  QueryDefinition
} from "@reduxjs/toolkit/dist/query";
import {
  LazyQueryTrigger,
  MutationTrigger
} from "@reduxjs/toolkit/dist/query/react/buildHooks";
import { QueryArgs } from "@testing-library/react";
import { ApiResponse, GetAllRequest } from "apis/api-types";

const getOptionsLoadMore = async (
  callback:
    | LazyQueryTrigger<
      QueryDefinition<
        void | GetAllRequest | any,
        BaseQueryFn,
        never,
        ApiResponse<any>
      >
    >
    | MutationTrigger<
      MutationDefinition<
        void | GetAllRequest,
        BaseQueryFn,
        never,
        ApiResponse<any>
      >
    >,
  params: GetAllRequest,
  labelKey = "name",
  valueKey = "id"
) => {
  try {
    const { PageIndex, PageSize } = params;
    const results = await callback(params).unwrap();

    const { items, totalCount } = results;
    if (items && items.length > 0) {
      const convertResult = items.map((item: any) => ({
        ...item,
        value: item?.[valueKey] || "",
        label: item?.[labelKey] || ""
      }));
      return {
        options: convertResult,
        hasMore:
          PageIndex && PageSize
            ? Math.ceil(totalCount / (PageSize || 1)) > (PageIndex || 1)
            : false
      };
    }
    return {
      options: [],
      hasMore: false
    };
  } catch (error) {
    return {
      options: [],
      hasMore: false
    };
  }
};

export default getOptionsLoadMore;
